import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { OutlinedComponent } from '@inter-ikea-core/core';
import { isOfType, PlannerProductComponent, getProductReferenceFor, getProduct, ProductInfoComponent, ShoppingBagComponent, InteriorComponent, isUnavailableProduct, UnavailableProductComponent, isProductPart, OuterMeasurementsComponent, AssemblyInstructionsComponent, HideInSeeThroughSystemComponent, ProductType, DistanceMeasurementComponent, NonDuplicatableComponent } from '@inter-ikea-storageone/range';
import { Direction } from '@inter-ikea-storageone/range/src/core-api/components/DistanceMeasurementComponent';
export const boaxelComponentResolver = (coreApi, products, unavailableProducts, productsNotInMarket, coreSpecificProducts) => {
    const isShoppingProduct = isOfType([
        ProductType.BOAXEL_MOUNTING_RAIL_EXT,
        ProductType.BOAXEL_ADJ_SHELF_EXT,
        ProductType.BOAXEL_ADJ_CLOTHES_RAIL_EXT,
        ProductType.BOAXEL_UPRIGHT,
        ProductType.BOAXEL_BRACKET,
        ProductType.BOAXEL_CLOTHES_RAIL,
        ProductType.BOAXEL_INSERT
    ]);
    //Should include all product types that should be displayed in the product sidebar
    const isPlannerProduct = isOfType([
        ProductType.BOAXEL_SHELF,
        ProductType.BOAXEL_ADJ_SHELF,
        ProductType.BOAXEL_SHOE_SHELF,
        ProductType.BOAXEL_WIRE_SHELF,
        ProductType.BOAXEL_DRYING_RACK,
        ProductType.BOAXEL_UPRIGHT,
        ProductType.BOAXEL_MESH_BASKET,
        ProductType.BOAXEL_CLOTHES_RAIL,
        ProductType.BOAXEL_METAL_SHELF,
        ProductType.BOAXEL_UPRIGHT_SECTION
    ]);
    const shouldBeIncludedInOuterMeasurement = isOfType([
        ProductType.BOAXEL_SHELF,
        ProductType.BOAXEL_ADJ_SHELF,
        ProductType.BOAXEL_SHOE_SHELF,
        ProductType.BOAXEL_WIRE_SHELF,
        ProductType.BOAXEL_DRYING_RACK,
        ProductType.BOAXEL_UPRIGHT,
        ProductType.BOAXEL_MESH_BASKET,
        ProductType.BOAXEL_CLOTHES_RAIL,
        ProductType.BOAXEL_ADJ_CLOTHES_RAIL,
        ProductType.BOAXEL_METAL_SHELF,
        ProductType.BOAXEL_UPRIGHT_SECTION
    ]);
    const shouldHaveInnerDistanceMeasurement = isOfType([
        ProductType.BOAXEL_SHELF,
        ProductType.BOAXEL_ADJ_SHELF,
        ProductType.BOAXEL_SHOE_SHELF,
        ProductType.BOAXEL_WIRE_SHELF,
        ProductType.BOAXEL_DRYING_RACK,
        ProductType.BOAXEL_MESH_BASKET,
        ProductType.BOAXEL_CLOTHES_RAIL,
        ProductType.BOAXEL_METAL_SHELF
    ]);
    const shouldHaveAssemblyInstructions = isOfType([]);
    const isInterior = isOfType([
        ProductType.BOAXEL_SHELF,
        ProductType.BOAXEL_ADJ_SHELF,
        ProductType.BOAXEL_SHOE_SHELF,
        ProductType.BOAXEL_WIRE_SHELF,
        ProductType.BOAXEL_DRYING_RACK,
        ProductType.BOAXEL_MESH_BASKET,
        ProductType.BOAXEL_CLOTHES_RAIL,
        ProductType.BOAXEL_ADJ_CLOTHES_RAIL,
        ProductType.BOAXEL_METAL_SHELF
    ]);
    const hideInSeeThroughEntitySystem = isOfType([]);
    const isNonDuplicatable = isOfType([ProductType.BOAXEL_NON_MOUNTING_RAIL]);
    const componentBuilder = {
        build: (entity) => {
            const product = getProduct(entity, [
                ...products,
                ...unavailableProducts,
                ...productsNotInMarket,
                ...coreSpecificProducts
            ]);
            if (product) {
                entity.addComponent(new ProductInfoComponent(product.globalItemNo, product.name, product.type, product.design));
            }
            if (shouldBeIncludedInOuterMeasurement(entity)) {
                if (HierarchyUtils.isAssembly(entity)) {
                    // If we add the outer measurement to the assembly we don't get depth measurement of the shelf.
                    // This way we find the insert part of the assembly and add it to that instead.
                    const assemblyParts = HierarchyUtils.getDescendantsWithComponent(entity, ComponentIds.PRODUCT_PART_COMPONENT_ID);
                    const insertEntity = assemblyParts.find(e => e.getComponent(ComponentIds.PRODUCT_PART_COMPONENT_ID)
                        ?.partKey === 'insert');
                    insertEntity?.addComponent(new OuterMeasurementsComponent());
                }
                else
                    entity.addComponent(new OuterMeasurementsComponent());
            }
            if (shouldHaveInnerDistanceMeasurement(entity)) {
                entity.addComponent(new DistanceMeasurementComponent([Direction.UP, Direction.DOWN]));
            }
            if (isUnavailableProduct(entity, unavailableProducts) && !isProductPart(entity)) {
                entity.addComponent(new UnavailableProductComponent());
                entity.addComponent(new OutlinedComponent());
                entity.removeComponent(ComponentIds.SELECTABLE_COMPONENT_ID);
            }
            if (isPlannerProduct(entity)) {
                entity.addComponent(new PlannerProductComponent(getProductReferenceFor(entity)));
            }
            if (isShoppingProduct(entity)) {
                entity.addComponent(new ShoppingBagComponent(getProductReferenceFor(entity)));
            }
            if (isInterior(entity)) {
                entity.addComponent(new InteriorComponent());
            }
            if (shouldHaveAssemblyInstructions(entity)) {
                entity.addComponent(new AssemblyInstructionsComponent());
            }
            if (hideInSeeThroughEntitySystem(entity)) {
                entity.addComponent(new HideInSeeThroughSystemComponent());
            }
            if (isNonDuplicatable(entity)) {
                entity.addComponent(new NonDuplicatableComponent());
            }
        }
    };
    return {
        resolveComponentBuilder: () => componentBuilder
    };
};
//# sourceMappingURL=boaxelComponentResolver.js.map